import { ICreateCustomerContext } from './createCustomerContext';

export enum CreateCustomerActionTypes {
	SET_FILE = 'SET_FILE',
	CHANGE_NAME = 'CHANGE_NAME',
	CHANGE_EMAIL = 'CHANGE_EMAIL',
	CHANGE_EMAIL_BODY_TEMPLATE = 'CHANGE_EMAIL_BODY_TEMPLATE',
	SET_CLIENT_TYPE = 'SET_CLIENT_TYPE',
	CHANGE_BILL_TEMPLATE_FILE_DATA = 'CHANGE_BILL_TEMPLATE_FILE_DATA',
	CHANGE_BILL_ADVERTISING_IMAGE_DATA = 'CHANGE_BILL_ADVERTISING_IMAGE_DATA',
	CHANGE_BILL_ADVERTISING_LINK = 'CHANGE_BILL_ADVERTISING_LINK',
	CHANGE_PRICE_TYPE = 'CHANGE_PRICE_TYPE',
	SET_TIPS_0 = 'SET_TIPS_0',
	SET_TIPS_1 = 'SET_TIPS_1',
	SET_TIPS_2 = 'SET_TIPS_2',
	SET_TIPS_3 = 'SET_TIPS_3',
	SET_DEFAULT_TIPS = 'SET_DEFAULT_TIPS',
	SET_ADS = 'SET_ADS',
	SET_MIXPANEL_TOKEN = 'SET_MIXPANEL_TOKEN',
	SET_STOP_LIST_SYNC_INTERVAL_MINUTES = 'SET_STOP_LIST_SYNC_INTERVAL_MINUTES',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_ID_CUSTOMER_DEFAULT_LANGUAGE = 'SET_ID_CUSTOMER_DEFAULT_LANGUAGE',
	SET_IDs_CUSTOMER_LANGUAGES = 'SET_IDs_CUSTOMER_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetFile {
	type: CreateCustomerActionTypes.SET_FILE;
	payload: {
		fileId: ICreateCustomerContext['fileId'];
		sourceUrlLocally: ICreateCustomerContext['sourceUrlLocally'];
	};
}

interface IChangeName {
	type: CreateCustomerActionTypes.CHANGE_NAME;
	payload: {
		name: ICreateCustomerContext['name'];
	};
}

interface IChangeEmail {
	type: CreateCustomerActionTypes.CHANGE_EMAIL;
	payload: {
		email: ICreateCustomerContext['email'];
	};
}

interface IChangeEmailBodyTemplate {
	type: CreateCustomerActionTypes.CHANGE_EMAIL_BODY_TEMPLATE;
	payload: {
		emailBodyTemplate: ICreateCustomerContext['emailBodyTemplate'];
	};
}

interface ISetClientType {
	type: CreateCustomerActionTypes.SET_CLIENT_TYPE;
	payload: {
		clientType: ICreateCustomerContext['clientType'];
	};
}

interface IChangeBillTemplateFileData {
	type: CreateCustomerActionTypes.CHANGE_BILL_TEMPLATE_FILE_DATA;
	payload: {
		billTemplateFileData: ICreateCustomerContext['billTemplateFileData'];
	};
}

interface IChangeBillAdvertisingImageData {
	type: CreateCustomerActionTypes.CHANGE_BILL_ADVERTISING_IMAGE_DATA;
	payload: {
		billAdvertisingImageData: ICreateCustomerContext['billAdvertisingImageData'];
	};
}

interface IChangeBillAdvertisingLink {
	type: CreateCustomerActionTypes.CHANGE_BILL_ADVERTISING_LINK;
	payload: {
		billAdvertisingLink: ICreateCustomerContext['billAdvertisingLink'];
	};
}

interface IChangePriceType {
	type: CreateCustomerActionTypes.CHANGE_PRICE_TYPE;
	payload: {
		priceType: ICreateCustomerContext['priceType'];
	};
}

interface ISetTips0 {
	type: CreateCustomerActionTypes.SET_TIPS_0;
	payload: {
		tips0: ICreateCustomerContext['tips0'];
	};
}

interface ISetTips1 {
	type: CreateCustomerActionTypes.SET_TIPS_1;
	payload: {
		tips1: ICreateCustomerContext['tips1'];
	};
}

interface ISetTips2 {
	type: CreateCustomerActionTypes.SET_TIPS_2;
	payload: {
		tips2: ICreateCustomerContext['tips2'];
	};
}

interface ISetTips3 {
	type: CreateCustomerActionTypes.SET_TIPS_3;
	payload: {
		tips3: ICreateCustomerContext['tips3'];
	};
}

interface ISetDefaultTips {
	type: CreateCustomerActionTypes.SET_DEFAULT_TIPS;
	payload: {
		defaultTips: ICreateCustomerContext['defaultTips'];
	};
}

interface ISetAds {
	type: CreateCustomerActionTypes.SET_ADS;
	payload: {
		ads: ICreateCustomerContext['ads'];
	};
}

interface ISetMixpanelToken {
	type: CreateCustomerActionTypes.SET_MIXPANEL_TOKEN;
	payload: {
		mixpanelToken: ICreateCustomerContext['mixpanelToken'];
	};
}

interface ISetStopListSyncIntervalMinutes {
	type: CreateCustomerActionTypes.SET_STOP_LIST_SYNC_INTERVAL_MINUTES;
	payload: {
		stopListSyncIntervalMinutes: ICreateCustomerContext['stopListSyncIntervalMinutes'];
	};
}

interface ISetFetchedLanguages {
	type: CreateCustomerActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		fetchedLanguages: ICreateCustomerContext['fetchedLanguages'];
	};
}

interface ISetIDCustomerDefaultLanguage {
	type: CreateCustomerActionTypes.SET_ID_CUSTOMER_DEFAULT_LANGUAGE;
	payload: {
		IDSelectedCustomerDefaultLanguage: ICreateCustomerContext['IDSelectedCustomerDefaultLanguage'];
	};
}

interface ISetIDsCustomerLanguages {
	type: CreateCustomerActionTypes.SET_IDs_CUSTOMER_LANGUAGES;
	payload: {
		IDsSelectedCustomerLanguages: ICreateCustomerContext['IDsSelectedCustomerLanguages'];
	};
}

interface ISetDataForSubmit {
	type: CreateCustomerActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateCustomerContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateCustomerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: ICreateCustomerContext['typeOfModalWindow'];
	};
}

interface IResetSelectedControls {
	type: CreateCustomerActionTypes.RESET_FIELDS;
}

export type TCreateCustomerAction =
	| ISetFile
	| IChangeName
	| IChangeEmail
	| IChangeEmailBodyTemplate
	| ISetClientType
	| IChangeBillTemplateFileData
	| IChangeBillAdvertisingImageData
	| IChangeBillAdvertisingLink
	| IChangePriceType
	| ISetTips0
	| ISetTips1
	| ISetTips2
	| ISetTips3
	| ISetDefaultTips
	| ISetAds
	| ISetMixpanelToken
	| ISetStopListSyncIntervalMinutes
	| ISetFetchedLanguages
	| ISetIDCustomerDefaultLanguage
	| ISetIDsCustomerLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
